































import { publicationsTransferRequest } from '@/core/api/publications-transfer'
import Vue from 'vue'

export default Vue.extend({
  props: {
    src: {
      type: Object,
      default: null,
    },
    dst: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    isActionActive(): boolean {
      return this.src && this.dst && !this.loading
    },
  },
  methods: {
    async submit() {
      const { dismiss } = await this.$modalConfirm.fire({
        title: 'Подтверждение переноса новостей',
        html: `
          Перенести все новости из источника <b>${this.src.name}</b> в источник <b>${this.dst.name}</b>?
          <br />
          Перенос будет происходить в фоновом режиме.
          <br />
          <br />
          <b>Внимание!</b> <br />
          Операцию невозможно будет отменить.
        `,
      })
      if (dismiss) {
        return
      }

      this.loading = true
      publicationsTransferRequest(this.src.id, this.dst.id)
        .then(() => {
          this.$toastSuccess.fire({
            title: 'Запрос отправлен, новости будут перенесены в ближайшее время',
          })
          this.$emit('submit')
        })
        .catch(() => {
          this.$toastError.fire()
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
})
